module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCI+PHBhdGggZD0iTTAgMGgyNHYyNEgwWiIgc3R5bGU9ImZpbGw6bm9uZSIvPjxwYXRoIGQ9Ik0yMCA0SDRhMiAyIDAgMCAwLTEuOTkgMkwyIDE4YTIuMDA2IDIuMDA2IDAgMCAwIDIgMmgxNmEyLjAwNiAyLjAwNiAwIDAgMCAyLTJWNmEyLjAwNiAyLjAwNiAwIDAgMC0yLTJabTAgNC04IDUtOC01VjZsOCA1IDgtNVoiIHN0eWxlPSJmaWxsOiNmZmY7b3BhY2l0eTouNyIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_mail.svg
// module id = xLAB
// module chunks = 98